// ------------------------------------
// CORES E PLANO DE FUNDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const ref2 = 'styles';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('#footer');

    // Altera o tipo de fundo
    function changeBgType() {
      const value = confTheme[ref]['bg-type'];
      if (value == 'image') {
        changeBgImage();
      } else if (value == 'gradient') {
        changeBgGradient();
      } else if (value == 'color') {
        changeBgColor();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

    // Altera a imagem de fundo
    function changeBgImage() {
      const image = confTheme[ref]['bg-image'];
      $section.css('background-image', 'url(' + image + ')');
    }
    $root.on(refEvtPrefix + 'bg-image', changeBgImage);

    // Altera o gradiente de fundo
    function changeBgGradient() {
      const value = confTheme[ref]['bg-gradient'];
      $section.css('background-image', value);
    }
    $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref][ref2]['footer-bg-color'];
      $section.css('background-image', 'none');
      $section[0].style.setProperty('--footer-bg-color', color);
    }
    $root.on(refEvtPrefix + 'bg-color', changeBgColor);

    // Altera a cor dos títulos
    function changeTitColor() {
      const color = confTheme[ref][ref2]['footer-tit-color'];
      $section[0].style.setProperty('--footer-tit-color', color);
    }
    $root.on(refEvtPrefix + 'tit-color', changeTitColor);

    // Altera a cor dos textos
    function changeTxtColor() {
      const color = confTheme[ref][ref2]['footer-txt-color'];
      $section[0].style.setProperty('--footer-txt-color', color);
    }
    $root.on(refEvtPrefix + 'txt-color', changeTxtColor);

    // Altera a cor de hover
    function changeHvColor() {
      const color = confTheme[ref][ref2]['footer-hv-color'];
      $section[0].style.setProperty('--footer-hv-color', color);
    }
    $root.on(refEvtPrefix + 'hv-color', changeHvColor);
  }
})();

// ------------------------------------
// NEWSLETTER
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'newsletter';
    const ref2 = 'styles';
    const refEvtPrefix = 'lp-evt-newsletter-';

    // Elementos
    const $section = $('#newsletter');

    // Oculta/Exibe a seção
    function changeNewsShow() {
      const value = confTheme[ref]['show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'show', changeNewsShow);

    // Altera o tipo de fundo
    function changeBgType() {
      const value = confTheme[ref]['bg-type'];
      if (value == 'image') {
        changeBgImage();
      } else if (value == 'gradient') {
        changeBgGradient();
      } else if (value == 'color') {
        changeBgColor();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

    // Altera a imagem de fundo
    function changeBgImage() {
      const image = confTheme[ref]['bg-image'];
      $section.css('background-image', 'url(' + image + ')');
    }
    $root.on(refEvtPrefix + 'bg-image', changeBgImage);

    // Altera o gradiente de fundo
    function changeBgGradient() {
      const value = confTheme[ref]['bg-gradient'];
      $section.css('background-image', value);
    }
    $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref][ref2]['news-bg-color'];
      $section.css('background-image', 'none');
      $section[0].style.setProperty('--news-bg-color', color);
    }
    $root.on(refEvtPrefix + 'bg-color', changeBgColor);

    // Altera a cor dos títulos
    function changeTitColor() {
      const color = confTheme[ref][ref2]['news-tit-color'];
      $section[0].style.setProperty('--news-tit-color', color);
    }
    $root.on(refEvtPrefix + 'tit-color', changeTitColor);

    // Altera a cor dos textos
    function changeTxtColor() {
      const color = confTheme[ref][ref2]['news-txt-color'];
      $section[0].style.setProperty('--news-txt-color', color);
    }
    $root.on(refEvtPrefix + 'txt-color', changeTxtColor);

    // Altera o título
    function changeTit() {
      const value = confTheme[ref]['titulo'];
      $('.newsletter-tit').text(value);
    }
    $root.on(refEvtPrefix + 'titulo', changeTit);

    // Altera o texto
    function changeTxt() {
      const value = confTheme[ref]['texto'];
      $('.newsletter-txt').html(mdParse(value, true));
    }
    $root.on(refEvtPrefix + 'texto', changeTxt);

    // Altera o botão
    function changeBtnClass() {
      const value = confTheme[ref]['btn-class'];
      $section
        .find('.btn')
        .removeClass('btn-primary btn-secondary btn-buy btn-white outline')
        .addClass(value + ' ' + confTheme['general'][value + '-style']);
    }
    $root.on(refEvtPrefix + 'btn-class', changeBtnClass);
  }
})();

// ------------------------------------
// SOBRE
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('.footer-sobre');

    // Oculta/Exibe a coluna
    function changeColShow() {
      const value = confTheme[ref]['sobre-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'sobre-show', changeColShow);

    // Altera a ordem da coluna
    function changeOrder() {
      const order = confTheme[ref]['sobre-order'];
      $section[0].style.setProperty('order', order);
    }
    $root.on(refEvtPrefix + 'sobre-order', changeOrder);

    // Altera o título
    function changeTit() {
      const value = confTheme[ref]['sobre-titulo'];
      $section.find('.footer-tit').text(value);
    }
    $root.on(refEvtPrefix + 'sobre-titulo', changeTit);

    // Altera o texto
    function changeTxt() {
      const value = confTheme[ref]['sobre-texto'];
      $section.find('.md-text').html(mdParse(value, true));
    }
    $root.on(refEvtPrefix + 'sobre-texto', changeTxt);
  }
})();

// ------------------------------------
// PÁGINAS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('.footer-pags');
    const $list = $section.find('.footer-links');

    // Oculta/Exibe a coluna
    function changeColShow() {
      const value = confTheme[ref]['paginas-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'paginas-show', changeColShow);

    // Altera a ordem da coluna
    function changeOrder() {
      const order = confTheme[ref]['paginas-order'];
      $section[0].style.setProperty('order', order);
    }
    $root.on(refEvtPrefix + 'paginas-order', changeOrder);

    // Altera o título
    function changeTit() {
      const value = confTheme[ref]['paginas-titulo'];
      $section.find('.footer-tit').text(value);
    }
    $root.on(refEvtPrefix + 'paginas-titulo', changeTit);

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref]['paginas'];
      $list.html('');
      if ($list.length > 0) {
        for (let i = 0; i < lista.length; i++) {
          const item = `
          <li><a href="#"><span>${lista[i].titulo}</span></a></li>`;
          $list.append(item);
        }
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'paginas', changeList);

    // Altera 2 colunas
    function changeTwoColumns() {
      const value = confTheme[ref]['paginas-two-columns'];
      const catsTwoColumnsGridClass = value == '1' ? 'grid-3' : 'grid-2';
      $section.removeClass('grid-3 grid-2').addClass(catsTwoColumnsGridClass);
      value == '1'
        ? $section.find('.footer-links').addClass('two-columns')
        : $section.find('.footer-links').removeClass('two-columns');
    }
    $root.on(refEvtPrefix + 'paginas-two-columns', changeTwoColumns);
  }
})();

// ------------------------------------
// CATEGORIAS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('.footer-cats');

    // Oculta/Exibe a coluna
    function changeColShow() {
      const value = confTheme[ref]['categorias-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'categorias-show', changeColShow);

    // Altera a ordem da coluna
    function changeOrder() {
      const order = confTheme[ref]['categorias-order'];
      $section[0].style.setProperty('order', order);
    }
    $root.on(refEvtPrefix + 'categorias-order', changeOrder);

    // Altera o título
    function changeTit() {
      const value = confTheme[ref]['categorias-titulo'];
      $section.find('.footer-tit').text(value);
    }
    $root.on(refEvtPrefix + 'categorias-titulo', changeTit);

    // Altera 2 colunas
    function changeTwoColumns() {
      const value = confTheme[ref]['categorias-two-columns'];
      const catsTwoColumnsGridClass = value == '1' ? 'grid-3' : 'grid-2';
      $section.removeClass('grid-3 grid-2').addClass(catsTwoColumnsGridClass);
      value == '1'
        ? $section.find('.footer-links').addClass('two-columns')
        : $section.find('.footer-links').removeClass('two-columns');
    }
    $root.on(refEvtPrefix + 'categorias-two-columns', changeTwoColumns);
  }
})();

// ------------------------------------
// ATENDIMENTO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('.footer-atendimento');

    // Oculta/Exibe a coluna
    function changeColShow() {
      const value = confTheme[ref]['atendimento-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'atendimento-show', changeColShow);

    // Altera a ordem da coluna
    function changeOrder() {
      const order = confTheme[ref]['atendimento-order'];
      $section[0].style.setProperty('order', order);
    }
    $root.on(refEvtPrefix + 'atendimento-order', changeOrder);

    // Altera o título
    function changeTit() {
      const value = confTheme[ref]['atendimento-titulo'];
      $section.find('.footer-tit').text(value);
    }
    $root.on(refEvtPrefix + 'atendimento-titulo', changeTit);
  }
})();

// ------------------------------------
// SELOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('.footer-selos-col');
    const $list = $('.footer-selos');

    // Oculta/Exibe a coluna
    function changeColShow() {
      const value = confTheme[ref]['selos-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'selos-show', changeColShow);

    // Altera a ordem da coluna
    function changeOrder() {
      const order = confTheme[ref]['selos-order'];
      $section[0].style.setProperty('order', order);
    }
    $root.on(refEvtPrefix + 'selos-order', changeOrder);

    // Altera o título
    function changeTit() {
      const value = confTheme[ref]['selos-titulo'];
      $section.find('.footer-tit').text(value);
    }
    $root.on(refEvtPrefix + 'selos-titulo', changeTit);

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref]['selos'];
      $list.html('');
      if ($list.length > 0) {
        for (let i = 0; i < lista.length; i++) {
          const item = `
          <li><a href="${lista[i].url}"><img src="${lista[i].img}" width="200px" height="80px" alt="${lista[i].alt}"></a></li>`;
          $list.append(item);
        }
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'selos', changeList);
  }
})();

// ------------------------------------
// REDES SOCIAIS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const ref2 = 'styles';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('.footer-redes');

    // Oculta/Exibe a coluna
    function changeColShow() {
      const value = confTheme[ref]['redes-sociais-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-show', changeColShow);

    // Oculta/Exibe no atendimento
    function changeRedesAtendShow() {
      const value = confTheme[ref]['redes-sociais-atend-show'];
      value == '1'
        ? $('.footer-atendimento .social-icons').removeClass('d-none')
        : $('.footer-atendimento .social-icons').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-atend-show', changeRedesAtendShow);

    // Altera a ordem da coluna
    function changeOrder() {
      const order = confTheme[ref]['redes-sociais-order'];
      $section[0].style.setProperty('order', order);
    }
    $root.on(refEvtPrefix + 'redes-sociais-order', changeOrder);

    // Altera o título
    function changeTit() {
      const value = confTheme[ref]['redes-sociais-titulo'];
      $section.find('.footer-tit').text(value);
    }
    $root.on(refEvtPrefix + 'redes-sociais-titulo', changeTit);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref][ref2]['redes-sociais-bg-color'];
      $('#footer')[0].style.setProperty('--redes-sociais-bg-color', color);
    }
    $root.on(refEvtPrefix + 'redes-sociais-bg-color', changeBgColor);

    // Altera a cor do ícone
    function changeTxtColor() {
      const color = confTheme[ref][ref2]['redes-sociais-txt-color'];
      $('#footer')[0].style.setProperty('--redes-sociais-txt-color', color);
    }
    $root.on(refEvtPrefix + 'redes-sociais-txt-color', changeTxtColor);

    // Altera efeito outline
    function changeRedesOutline() {
      const value = confTheme[ref]['redes-sociais-outline'];
      value == '1'
        ? $('#footer .social-icon, .menu-mobile-footer-sociais .social-icon').addClass('outline')
        : $('#footer .social-icon, .menu-mobile-footer-sociais .social-icon').removeClass('outline');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-outline', changeRedesOutline);
  }
})();

// ------------------------------------
// PAGAMENTOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('.footer-pagamentos-wrp');

    // Oculta/Exibe a coluna
    function changeColShow() {
      const value = confTheme[ref]['pagamentos-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'pagamentos-show', changeColShow);

    // Altera o título
    function changeTit() {
      const value = confTheme[ref]['pagamentos-titulo'];
      $section.find('.footer-tit').text(value);
    }
    $root.on(refEvtPrefix + 'pagamentos-titulo', changeTit);
  }
})();

// ------------------------------------
// BARRA INFERIOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const ref2 = 'styles';
    const refEvtPrefix = 'lp-evt-footer-';

    // Elementos
    const $section = $('.footer-bar');

    // Altera o texto
    function changeTxt() {
      const value = confTheme[ref]['bar-text'];
      $section.find('.md-text').html(mdParse(value, true));
    }
    $root.on(refEvtPrefix + 'bar-text', changeTxt);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref][ref2]['bar-bg-color'];
      $('#footer')[0].style.setProperty('--bar-bg-color', color);
    }
    $root.on(refEvtPrefix + 'bar-bg-color', changeBgColor);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref][ref2]['bar-txt-color'];
      $('#footer')[0].style.setProperty('--bar-txt-color', color);
    }
    $root.on(refEvtPrefix + 'bar-txt-color', changeTxtColor);

    // Altera a cor da borda
    function changeBorderColor() {
      const color = confTheme[ref][ref2]['bar-border-color'];
      $('#footer')[0].style.setProperty('--bar-border-color', color);
    }
    $root.on(refEvtPrefix + 'bar-border-color', changeBorderColor);
  }
})();

// ------------------------------------
// OUTROS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'footer';
    const refEvtPrefix = 'lp-evt-footer-';

    // Oculta/Exibe a coluna
    function changeGotopShow() {
      const value = confTheme[ref]['gotop-show'];
      value == '1' ? $('.go-top').removeClass('d-none') : $('.go-top').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'gotop-show', changeGotopShow);
  }
})();
